import React from "react";
import { FinancialConnection } from "@common/types/financialConnection";
import { isPlaidConnection } from "@common/helpers/financialConnection";
import { PlaidAccountMetadata } from "@common/helpers/plaid";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { isIntegrationConnection } from "@common/helpers/integrationConnection";
import { AlertIcon } from "@icons";
import { BrokenPlaidConnectionLink } from "../plaid/BrokenPlaidConnectionLink";
import { BrokenFinancialConnectionLink } from "../financialAccount/BrokenFinancialConnectionLink";
import { FixIntegrationConnection } from "../integrationConnection/FixIntegrationConnection";
import {
    ConnectionButtonSize,
    ConnectionButtonVariant,
} from "./ConnectionActionButton";

interface Props {
    connection: FinancialConnection | IntegrationConnection;
    integrationAccount?: IntegrationAccount;
    integrationTriggerContent?: React.ReactNode;
    integrationTriggerVariant?: ConnectionButtonVariant;
    integrationTriggerSize?: ConnectionButtonSize;
    integrationTriggerLeftIcon?: React.ReactNode;
    integrationTriggerTooltip?: React.ReactNode;
    onFixed?: () => void;
}

export const BrokenConnectionLink: React.FC<Props> = ({
    connection,
    integrationAccount,
    integrationTriggerContent = "Fix connection",
    integrationTriggerVariant = "link",
    integrationTriggerSize = "sm",
    integrationTriggerLeftIcon = <AlertIcon className="icon-color-red-500" />,
    integrationTriggerTooltip,
    onFixed,
}) => {
    if (isIntegrationConnection(connection)) {
        return (
            <FixIntegrationConnection
                integrationConnection={connection}
                onFixed={onFixed}
                variant={integrationTriggerVariant}
                size={integrationTriggerSize}
                leftIcon={integrationTriggerLeftIcon}
                tooltip={integrationTriggerTooltip}
            >
                {integrationTriggerContent}
            </FixIntegrationConnection>
        );
    }

    if (isPlaidConnection(connection)) {
        return (
            <BrokenPlaidConnectionLink
                connection={connection}
                onFixed={onFixed}
                churnedAccount={
                    integrationAccount?.metadata?.[
                        PlaidAccountMetadata.ACCOUNT_CHURN
                    ]
                        ? integrationAccount
                        : undefined
                }
                triggerContent={integrationTriggerContent}
                triggerVariant={integrationTriggerVariant}
                triggerSize={integrationTriggerSize}
                triggerLeftIcon={integrationTriggerLeftIcon}
                triggerTooltip={integrationTriggerTooltip}
            />
        );
    }

    return (
        <BrokenFinancialConnectionLink
            connection={connection}
            onFixed={onFixed}
            triggerContent={integrationTriggerContent}
            triggerVariant={integrationTriggerVariant}
            triggerSize={integrationTriggerSize}
            triggerLeftIcon={integrationTriggerLeftIcon}
            triggerTooltip={integrationTriggerTooltip}
        />
    );
};
